import print from 'print-js';
import moment from 'moment';

import DefaultDialogController from 'utils/notifications/default-dialog-controller';

import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { downloadManageInventoryDetailedReportByTab } from '../../actions/download-detailed-report-by-tab.actions';
import { resetDetailsDialogData } from 'manage-inventory/actions/manage-inventory.actions';
import { fetchOrderDetails } from 'manage-inventory/actions/fetch-order-details.actions';
import { fetchPackDetails } from 'manage-inventory/actions/fetch-pack-details.actions';

const mapStateToThis = ({ ui, manageInventory, session, config, retailerDetails, dictionary }) => {
  const { detailsDialogActiveTab: activeTab } = ui;
  const { userSelection, orderDetails } = manageInventory;
  const { retailer, locale } = session;
  const { dateFormatPrintables } = config;
  const terms = dictionary.terms[locale];

  return {
    activeTab,
    userSelection,
    orderDetails,
    retailer,
    dateFormatPrintables,
    retailerDetails,
    terms,
  };
};

const mapDispatchToThis = {
  setActiveTab,
  downloadManageInventoryDetailedReportByTab,
  resetDetailsDialogData,
  fetchOrderDetails,
  fetchPackDetails,
};

@Inject('$ngRedux', '$state', 'gettextCatalog')
export class DetailsDialogController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.setTextForTabs();
    this.initializeTab();
    await this.fetchData();
  }

  $onDestroy() {
    this.setActiveTab('', 'detailsDialogActiveTab');
    this.resetDetailsDialogData();
    this.unsubscribe();
  }

  setActions() {
    this.actions = [
      {
        type: 'download',
        function: this.onReportDownload.bind(this),
        extension: 'xlsx',
        data: this.getReportDetails(),
      },
      {
        type: 'print',
        function: this.print.bind(this),
      },
    ];
  }

  initializeTab() {
    if (this.resolve.hidePackDetails) return this.setActiveTab(this.tabs.order.id, 'detailsDialogActiveTab');
    this.setActiveTab(this.tabs.pack.id, 'detailsDialogActiveTab');
    this.shouldDisplayTabs();
  }

  async onTabChange(tabId) {
    this.setActiveTab(tabId, 'detailsDialogActiveTab');
    await this.fetchData();
  }

  async fetchData() {
    const params = {
      retailerId: this.$state.params.retailerNo,
    };
    if (this.activeTab === this.tabs.order.id) {
      await this.fetchOrderDetails(params);
    } else if (this.activeTab === this.tabs.pack.id) {
      await this.fetchPackDetails(params);
    }
    this.setActions();
  }

  shouldDisplayTabs() {
    this.displayTabs = !this.resolve.hidePackDetails && !this.resolve.hideOrderDetails;
  }

  onReportDownload() {
    const config = {
      ...this.userSelection,
      tabId: this.activeTab,
    };

    return this.downloadManageInventoryDetailedReportByTab(config);
  }

  getReportDetails() {
    const customFileName = this.generateCustomFileName();

    return {
      customFileName,
      extension: 'xlsx',
    };
  }

  generateCustomFileName() {
    const retailerNumber = this.userSelection.retailerNumber || this.retailer.retailerDisplayNumber || this.retailerDetails.displayNumber;
    let reportName = '';
    const { gameNumber, packNo } = this.userSelection;
    const { orderNumber } = this.orderDetails;
    const date = moment().format(this.dateFormatPrintables || 'YYYY_MM_DD');

    switch (this.activeTab) {
      case 'pack':
        /// {{ pack }} is Lottery term using to determine Pack.
        reportName = this.gettextCatalog.getString('{{ pack }}_Details', { pack: this.terms.PACK.singular });
        return `${retailerNumber}_${reportName}_${gameNumber}-${packNo}_${date}`;

      case 'order':
        reportName = 'Order_Details';
        return `${retailerNumber}_${reportName}_${orderNumber}_${date}`;

      default:
        break;
    }
  }

  print() {
    print({
      printable: this.activeTab,
      type: 'html',
    });
  }

  setTextForTabs() {
    this.tabs = {
      order: {
        id: 'order',
        label: this.gettextCatalog.getString('Order'),
      },
      pack: {
        id: 'pack',
        /// {{ pack }} is Lottery term using to determine Pack.
        label: this.gettextCatalog.getString('{{ pack }}', { pack: this.terms.PACK.singular }),
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/details-dialog/details-dialog.controller.js